import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, unref as _unref, renderList as _renderList, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "wage-report-modal" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "header-actions" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "table-wrapper" }
const _hoisted_7 = { class: "wage-report-table" }
const _hoisted_8 = { class: "header-row-1" }
const _hoisted_9 = ["colspan"]
const _hoisted_10 = {
  key: 0,
  colspan: "2",
  class: "section-adjust"
}
const _hoisted_11 = ["colspan"]
const _hoisted_12 = ["colspan"]
const _hoisted_13 = { class: "header-row-2" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "nontax-col"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = { key: 4 }
const _hoisted_22 = { key: 5 }
const _hoisted_23 = { key: 6 }
const _hoisted_24 = { key: 7 }
const _hoisted_25 = { key: 8 }
const _hoisted_26 = { key: 9 }
const _hoisted_27 = {
  key: 10,
  class: "nontax-col"
}
const _hoisted_28 = {
  key: 11,
  class: "nontax-col"
}
const _hoisted_29 = {
  key: 12,
  class: "nontax-col"
}
const _hoisted_30 = { key: 14 }
const _hoisted_31 = { key: 15 }
const _hoisted_32 = { key: 16 }
const _hoisted_33 = { key: 17 }
const _hoisted_34 = { key: 18 }
const _hoisted_35 = { key: 19 }
const _hoisted_36 = { key: 20 }
const _hoisted_37 = { key: 21 }
const _hoisted_38 = { key: 22 }
const _hoisted_39 = { key: 23 }
const _hoisted_40 = { key: 24 }
const _hoisted_41 = { key: 25 }
const _hoisted_42 = { key: 26 }
const _hoisted_43 = { key: 27 }
const _hoisted_44 = { key: 28 }
const _hoisted_45 = { key: 29 }
const _hoisted_46 = { key: 30 }
const _hoisted_47 = { class: "center" }
const _hoisted_48 = { class: "center" }
const _hoisted_49 = { class: "center" }
const _hoisted_50 = { class: "center" }
const _hoisted_51 = { class: "right" }
const _hoisted_52 = { class: "right" }
const _hoisted_53 = { class: "right" }
const _hoisted_54 = { class: "right" }
const _hoisted_55 = {
  key: 0,
  class: "right"
}
const _hoisted_56 = {
  key: 1,
  class: "right nontax-col"
}
const _hoisted_57 = {
  key: 0,
  class: "right"
}
const _hoisted_58 = {
  key: 1,
  class: "right"
}
const _hoisted_59 = {
  key: 2,
  class: "right"
}
const _hoisted_60 = {
  key: 2,
  class: "right"
}
const _hoisted_61 = {
  key: 3,
  class: "right"
}
const _hoisted_62 = {
  key: 4,
  class: "right"
}
const _hoisted_63 = {
  key: 5,
  class: "right"
}
const _hoisted_64 = {
  key: 6,
  class: "right"
}
const _hoisted_65 = {
  key: 7,
  class: "right"
}
const _hoisted_66 = {
  key: 8,
  class: "right"
}
const _hoisted_67 = {
  key: 9,
  class: "right"
}
const _hoisted_68 = {
  key: 10,
  class: "right nontax-col"
}
const _hoisted_69 = {
  key: 11,
  class: "right nontax-col"
}
const _hoisted_70 = {
  key: 12,
  class: "right nontax-col"
}
const _hoisted_71 = ["title"]
const _hoisted_72 = ["title"]
const _hoisted_73 = { class: "right" }
const _hoisted_74 = {
  key: 14,
  class: "right"
}
const _hoisted_75 = {
  key: 15,
  class: "right"
}
const _hoisted_76 = {
  key: 16,
  class: "right"
}
const _hoisted_77 = {
  key: 17,
  class: "right"
}
const _hoisted_78 = {
  key: 18,
  class: "right"
}
const _hoisted_79 = {
  key: 19,
  class: "right"
}
const _hoisted_80 = {
  key: 20,
  class: "right"
}
const _hoisted_81 = {
  key: 21,
  class: "right"
}
const _hoisted_82 = {
  key: 22,
  class: "right"
}
const _hoisted_83 = {
  key: 23,
  class: "right"
}
const _hoisted_84 = ["title"]
const _hoisted_85 = { class: "right net-col" }
const _hoisted_86 = {
  key: 24,
  class: "right"
}
const _hoisted_87 = {
  key: 25,
  class: "right"
}
const _hoisted_88 = {
  key: 26,
  class: "right"
}
const _hoisted_89 = {
  key: 27,
  class: "right"
}
const _hoisted_90 = {
  key: 28,
  class: "right"
}
const _hoisted_91 = {
  key: 29,
  class: "right"
}
const _hoisted_92 = {
  key: 30,
  class: "right"
}
const _hoisted_93 = ["title"]
const _hoisted_94 = { class: "total-row" }
const _hoisted_95 = { class: "right" }
const _hoisted_96 = {
  key: 0,
  class: "right"
}
const _hoisted_97 = {
  key: 1,
  class: "right nontax-col"
}
const _hoisted_98 = {
  key: 0,
  class: "right"
}
const _hoisted_99 = {
  key: 1,
  class: "right"
}
const _hoisted_100 = {
  key: 2,
  class: "right"
}
const _hoisted_101 = {
  key: 2,
  class: "right"
}
const _hoisted_102 = {
  key: 3,
  class: "right"
}
const _hoisted_103 = {
  key: 4,
  class: "right"
}
const _hoisted_104 = {
  key: 5,
  class: "right"
}
const _hoisted_105 = {
  key: 6,
  class: "right"
}
const _hoisted_106 = {
  key: 7,
  class: "right"
}
const _hoisted_107 = {
  key: 8,
  class: "right"
}
const _hoisted_108 = {
  key: 9,
  class: "right"
}
const _hoisted_109 = {
  key: 10,
  class: "right"
}
const _hoisted_110 = {
  key: 11,
  class: "right"
}
const _hoisted_111 = {
  key: 12,
  class: "right"
}
const _hoisted_112 = ["title"]
const _hoisted_113 = ["title"]
const _hoisted_114 = { class: "right" }
const _hoisted_115 = {
  key: 14,
  class: "right"
}
const _hoisted_116 = {
  key: 15,
  class: "right"
}
const _hoisted_117 = {
  key: 16,
  class: "right"
}
const _hoisted_118 = {
  key: 17,
  class: "right"
}
const _hoisted_119 = {
  key: 18,
  class: "right"
}
const _hoisted_120 = {
  key: 19,
  class: "right"
}
const _hoisted_121 = {
  key: 20,
  class: "right"
}
const _hoisted_122 = {
  key: 21,
  class: "right"
}
const _hoisted_123 = {
  key: 22,
  class: "right"
}
const _hoisted_124 = {
  key: 23,
  class: "right"
}
const _hoisted_125 = ["title"]
const _hoisted_126 = { class: "right net-col" }
const _hoisted_127 = {
  key: 24,
  class: "right"
}
const _hoisted_128 = {
  key: 25,
  class: "right"
}
const _hoisted_129 = {
  key: 26,
  class: "right"
}
const _hoisted_130 = {
  key: 27,
  class: "right"
}
const _hoisted_131 = {
  key: 28,
  class: "right"
}
const _hoisted_132 = {
  key: 29,
  class: "right"
}
const _hoisted_133 = {
  key: 30,
  class: "right"
}
const _hoisted_134 = ["title"]

import { ref, computed } from 'vue';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import type { CommonWageListRow, CommonWageTaxRate } from '@/types/commonWage';
import {
  getCommonWageLedgerGrossPay,
  calcCommonWageLedgerNetPay,
  getCommonWageOvertimeTotal,
  getCommonWageNightTotal,
  getCommonWageHolidayTotal,
  getCommonWagePremiumNontaxTotal,
  getCommonWagePremiumTaxTotal,
  sumCommonWagePayParts,
  isCommonWageAmountEqual,
  isCommonWageLaborTotalMismatch,
  isCommonWageCorpTotalMismatch,
  isCommonWageTaxableMismatch,
  dbCommonWageAmount,
  COMMON_WAGE_CLIENT_NONTAX_LABELS,
  applyCommonWageAccountingDisplay,
  previewCommonWageRetirement,
} from '@/policies/commonWageSettingPolicy';
import { compareJobThenName } from '@/policies/jobTypeSort';
import {
  taxRateInfoToRates,
  type IncomeTaxRow,
} from '@/composables/wage/useCommonWageCalc';
import { buildCommonWageAccountingReportRow } from '@/composables/wage/useCommonWageBulkSave';

interface Props {
  year: number;
  month: number;
  wageData: CommonWageListRow[];
  memberName?: string;
  /** 회계용 공제 재산출용 — 없으면 지급칸 채움만 하고 공제는 저장값 */
  taxRateInfo?: CommonWageTaxRate | null;
  incomeTaxTable?: IncomeTaxRow[];
  /** 마감된 연월 — 공제·퇴직금은 저장값 유지 (회계용 중식 실비변상·생산직 비과세 표시는 적용) */
  snapshotOnly?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonWageReportExcel',
  props: {
    year: {},
    month: {},
    wageData: {},
    memberName: {},
    taxRateInfo: { default: null },
    incomeTaxTable: { default: () => [] },
    snapshotOnly: { type: Boolean, default: false }
  },
  emits: ["error"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const showModal = ref(false);
const isDownloading = ref(false);
const reportType = ref<'accounting' | 'client'>('accounting');

const props = __props;

const emit = __emit;

// 만나이 계산
const calculateAge = (birthDateStr: string | undefined, year: number, month: number) => {
  if (!birthDateStr) return '';
  const birthDate = new Date(birthDateStr);
  const baseDate = new Date(year, month - 1, 1);
  let age = baseDate.getFullYear() - birthDate.getFullYear();
  if (baseDate.getMonth() < birthDate.getMonth() || 
      (baseDate.getMonth() === birthDate.getMonth() && baseDate.getDate() < birthDate.getDate())) {
    age--;
  }
  return age > 0 ? `만${age}세` : '';
};

function sortWageRows(rows: CommonWageListRow[]): CommonWageListRow[] {
  return [...rows].sort((a, b) =>
    compareJobThenName(getJobType(a), a.ce_name, getJobType(b), b.ce_name)
  );
}

const getJobType = (row: CommonWageListRow) => row.ce_job_type || row.ce_position || '';

const getBirthDateStr = (row: CommonWageListRow) => {
  const raw = row.cwhd_birth || row.ce_birth_date;
  if (!raw) return '';
  return String(raw).substring(0, 10);
};

// 숫자 포맷팅
const formatNumber = (num: number | undefined | null) => {
  const n = Number(num) || 0;
  return n.toLocaleString();
};

// 소수점 포맷팅 (정수면 소수점 제거)
/** 엑셀 합계 키 — 근로자/기관 국민연금처럼 라벨이 같아도 컬럼을 구분 */
const excelColTotalKey = (col: { field?: string | null; name: string }) =>
  col.field || col.name;

/** 시트 맨 위 제목 */
const wageLedgerTitle = () => {
  const facility = (props.memberName || '').trim();
  const period = `${props.year}년 ${props.month}월 임금대장`;
  return facility ? `${facility} ${period}` : period;
};

const addWageLedgerTitleRow = (worksheet: ExcelJS.Worksheet, title: string, colCount: number) => {
  const titleRow = worksheet.addRow([title]);
  titleRow.height = 32;
  const lastCol = Math.max(colCount, 1);
  for (let i = 1; i <= lastCol; i++) {
    const cell = titleRow.getCell(i);
    cell.font = { bold: true, size: 16, color: { argb: 'FF1e3a5f' } };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
  }
  if (lastCol > 1) {
    worksheet.mergeCells(1, 1, 1, lastCol);
  }
};

const formatDecimal = (num: number | undefined | null) => {
  const n = Number(num) || 0;
  return n % 1 === 0 ? n.toFixed(0) : n.toString();
};

function toAccountingReportRow(row: CommonWageListRow): CommonWageListRow {
  const tax = props.taxRateInfo;
  const table = props.incomeTaxTable || [];
  if (!tax) {
    return applyCommonWageAccountingDisplay(row, { year: props.year, month: props.month });
  }
  return buildCommonWageAccountingReportRow(row, {
    taxRates: taxRateInfoToRates(tax),
    incomeTaxTable: table,
    year: props.year,
    month: props.month,
  });
}

/**
 * 열린 달 — 퇴직금은 한도 중식비 기준으로 고정하고, 기타공제·연말정산은 저장값(음수 포함)을 유지
 */
function applyOpenMonthAmounts(source: CommonWageListRow, view: CommonWageListRow): CommonWageListRow {
  const prevOut = dbCommonWageAmount(view.cwhd_c_out);
  const nextOut = previewCommonWageRetirement(source, props.year, props.month);
  const prevCorp = dbCommonWageAmount(view.cwhd_c_total);
  const prevEtc = dbCommonWageAmount(view.cwhd_l_etc);
  const nextEtc = dbCommonWageAmount(source.cwhd_l_etc);
  const prevYearend = dbCommonWageAmount(view.cwhd_l_yearend);
  const nextYearend = dbCommonWageAmount(source.cwhd_l_yearend);
  const prevLabor = dbCommonWageAmount(view.cwhd_l_total);
  return {
    ...view,
    cwhd_l_etc: nextEtc,
    cwhd_l_yearend: nextYearend,
    cwhd_l_total: prevLabor - prevEtc - prevYearend + nextEtc + nextYearend,
    cwhd_c_out: nextOut,
    cwhd_c_total: prevCorp - prevOut + nextOut,
  };
}

/**
 * 마감 달: 공제·퇴직금은 DB 저장값 유지.
 * 회계용만 중식 실비변상 한도 채움·생산직 비과세 칸을 표시에 반영
 * (DB에는 시설 입력 중식만 저장되므로 마감 후에도 채움을 건너뛰면 식대가 실비변상으로 안 보임)
 * 열린 달: 회계용은 공제까지 재산출, 기관용은 퇴직금만 재산출
 */
function reportRows(
  kind: 'accounting' | 'client',
  rows: CommonWageListRow[] | undefined
): CommonWageListRow[] {
  const list = rows || [];
  if (props.snapshotOnly) {
    if (kind === 'accounting') {
      return sortWageRows(
        list.map((row) =>
          applyCommonWageAccountingDisplay(row, { year: props.year, month: props.month })
        )
      );
    }
    return sortWageRows(list);
  }
  if (kind === 'accounting') {
    return sortWageRows(list.map((row) => applyOpenMonthAmounts(row, toAccountingReportRow(row))));
  }
  return sortWageRows(list.map((row) => applyOpenMonthAmounts(row, row)));
}

function rowsForCurrentReport(rows: CommonWageListRow[] | undefined): CommonWageListRow[] {
  return reportRows(reportType.value, rows);
}

// 정렬된 데이터
const sortedData = computed(() => rowsForCurrentReport(props.wageData));

// 합계 계산
const totals = computed(() => {
  const t = {
    base: 0, overtime: 0, overtimeNontax: 0, night: 0, nightNontax: 0,
    holiday: 0, holidayNontax: 0, premiumTax: 0, premiumNontax: 0, 
    overtimeTotal: 0, nightTotal: 0, holidayTotal: 0, // 고객용 합산
    dayoff: 0, longterm: 0, sunim: 0,
    bonus: 0, edu: 0, bojon: 0, etc: 0, dang: 0, lunch: 0, car: 0, childcare: 0,
    total: 0, taxable: 0, usual: 0,
    lYeon: 0, lGun: 0, lJang: 0, lGo: 0, lSo: 0, lJi: 0, lJiwon: 0, lSik: 0, lEtc: 0, lYearend: 0, lTotal: 0,
    cYeon: 0, cGun: 0, cJang: 0, cGo: 0, cSil: 0, cSan: 0, cOut: 0, cTotal: 0,
    netPay: 0
  };
  sortedData.value.forEach(row => {
    const gross = getCommonWageLedgerGrossPay(row);
    t.base += row.cwhd_basic || 0;
    t.overtime += row.cwhd_overtime || 0;
    t.overtimeNontax += row.cwhd_overtime_nontax || 0;
    t.night += row.cwhd_night || 0;
    t.nightNontax += row.cwhd_night_nontax || 0;
    t.holiday += row.cwhd_holiday || 0;
    t.holidayNontax += row.cwhd_holiday_nontax || 0;
    t.premiumTax += getCommonWagePremiumTaxTotal(row);
    t.premiumNontax += getCommonWagePremiumNontaxTotal(row);
    // 고객용 합산 합계
    t.overtimeTotal += getCommonWageOvertimeTotal(row);
    t.nightTotal += getCommonWageNightTotal(row);
    t.holidayTotal += getCommonWageHolidayTotal(row);
    t.dayoff += row.cwhd_dayoff || 0;
    t.longterm += row.cwhd_senior || 0;
    t.sunim += row.cwhd_sunim || 0;
    t.bonus += row.cwhd_bonus || 0;
    t.edu += row.cwhd_bosu || 0;
    t.bojon += row.cwhd_bojon || 0;
    t.etc += row.cwhd_other || 0;
    t.dang += row.cwhd_dang || 0;
    t.lunch += row.cwhd_lunch || 0;
    t.car += row.cwhd_car || 0;
    t.childcare += row.cwhd_child || 0;
    t.total += gross;
    t.taxable += row.cwhd_taxable || 0;
    t.usual += row.cwhd_usual || 0;
    t.lYeon += row.cwhd_l_yeon || 0;
    t.lGun += row.cwhd_l_gun || 0;
    t.lJang += row.cwhd_l_jang || 0;
    t.lGo += row.cwhd_l_go || 0;
    t.lSo += row.cwhd_l_so || 0;
    t.lJi += row.cwhd_l_ji || 0;
    t.lJiwon += row.cwhd_l_jiwon || 0;
    t.lSik += row.cwhd_l_sik || 0;
    t.lEtc += row.cwhd_l_etc || 0;
    t.lYearend += row.cwhd_l_yearend || 0;
    t.lTotal += row.cwhd_l_total || 0;
    t.cYeon += row.cwhd_c_yeon || 0;
    t.cGun += row.cwhd_c_gun || 0;
    t.cJang += row.cwhd_c_jang || 0;
    t.cGo += row.cwhd_c_go || 0;
    t.cSil += row.cwhd_c_sil || 0;
    t.cSan += row.cwhd_c_san || 0;
    t.cOut += row.cwhd_c_out || 0;
    t.cTotal += row.cwhd_c_total || 0;
    t.netPay += calcCommonWageLedgerNetPay(row, gross);
  });
  return t;
});

/** 0이 아닌 금액 — 환급(음수) 기타공제·연말정산도 칸을 연다 */
const amountPresent = (value: unknown): boolean => {
  const n = Number(value);
  return Number.isFinite(n) && n !== 0;
};

const hasNonZero = (field: keyof CommonWageListRow): boolean => {
  return sortedData.value.some(row => amountPresent(row[field]));
};

// 미리보기 컬럼 표시 여부 (0원인 항목 숨김)
const showColumns = computed(() => ({
  // 임금구성
  premiumTax:
    hasNonZero('cwhd_overtime') ||
    hasNonZero('cwhd_night') ||
    hasNonZero('cwhd_holiday'),
  premiumNontax:
    hasNonZero('cwhd_overtime_nontax') ||
    hasNonZero('cwhd_night_nontax') ||
    hasNonZero('cwhd_holiday_nontax'),
  dayoff: hasNonZero('cwhd_dayoff'),
  longterm: hasNonZero('cwhd_senior'),
  sunim: hasNonZero('cwhd_sunim'),
  bonus: hasNonZero('cwhd_bonus'),
  edu: hasNonZero('cwhd_bosu'),
  bojon: hasNonZero('cwhd_bojon'),
  etc: hasNonZero('cwhd_other'),
  dang: hasNonZero('cwhd_dang'),
  lunch: hasNonZero('cwhd_lunch'),
  car: hasNonZero('cwhd_car'),
  childcare: hasNonZero('cwhd_child'),
  // 근로자공제
  lYeon: hasNonZero('cwhd_l_yeon'),
  lGun: hasNonZero('cwhd_l_gun'),
  lJang: hasNonZero('cwhd_l_jang'),
  lGo: hasNonZero('cwhd_l_go'),
  lSo: hasNonZero('cwhd_l_so'),
  lJi: hasNonZero('cwhd_l_ji'),
  lJiwon: hasNonZero('cwhd_l_jiwon'),
  lSik: hasNonZero('cwhd_l_sik'),
  lEtc: hasNonZero('cwhd_l_etc'),
  lYearend: hasNonZero('cwhd_l_yearend'),
  // 기관공제
  cYeon: hasNonZero('cwhd_c_yeon'),
  cGun: hasNonZero('cwhd_c_gun'),
  cJang: hasNonZero('cwhd_c_jang'),
  cGo: hasNonZero('cwhd_c_go'),
  cSil: hasNonZero('cwhd_c_sil'),
  cSan: hasNonZero('cwhd_c_san'),
  cOut: hasNonZero('cwhd_c_out'),
}));

// 고객용: 연장/야간/휴일 합산 표시 여부
const showClientColumns = computed(() => ({
  overtimeTotal: props.wageData?.some(r => getCommonWageOvertimeTotal(r) > 0) ?? false,
  nightTotal: props.wageData?.some(r => getCommonWageNightTotal(r) > 0) ?? false,
  holidayTotal: props.wageData?.some(r => getCommonWageHolidayTotal(r) > 0) ?? false,
}));

// 고객용 합산 값 계산 (정책 단일 소스)
const getOvertimeTotal = (row: CommonWageListRow) => getCommonWageOvertimeTotal(row);
const getNightTotal = (row: CommonWageListRow) => getCommonWageNightTotal(row);
const getHolidayTotal = (row: CommonWageListRow) => getCommonWageHolidayTotal(row);
const getRowGrossPay = (row: CommonWageListRow) => getCommonWageLedgerGrossPay(row);
const getRowNetPay = (row: CommonWageListRow) => calcCommonWageLedgerNetPay(row);

/** 미리보기 — 합산 불일치 시 빨간 숫자 (신고용·기관확인용 공통) */
const isAccountingPreview = () => reportType.value === 'accounting';

/** 화면 항목 합 ≠ 임금합계 칸 (DB 저장값과 비교하지 않음 — 레거시 저장 불일치 오탐 방지) */
const rowWageMismatch = (row: CommonWageListRow) => {
  const parts = sumCommonWagePayParts(row);
  const displayed = getRowGrossPay(row);
  if (parts === 0 && displayed === 0) return false;
  return !isCommonWageAmountEqual(parts, displayed);
};
const rowLaborMismatch = (row: CommonWageListRow) => isCommonWageLaborTotalMismatch(row);
const rowCorpMismatch = (row: CommonWageListRow) => isCommonWageCorpTotalMismatch(row);
const rowTaxableMismatch = (row: CommonWageListRow) =>
  isAccountingPreview() && isCommonWageTaxableMismatch(row);

/** 하단 합계행 — 항목 세로합 vs 합계컬럼(표시값) */
const footerMismatch = computed(() => {
  const t = totals.value;
  const isClient = reportType.value === 'client';
  const wageParts = isClient
    ? t.base +
      t.overtimeTotal +
      t.nightTotal +
      t.holidayTotal +
      t.dayoff +
      t.longterm +
      t.sunim +
      t.bonus +
      t.edu +
      t.bojon +
      t.etc +
      t.dang +
      t.lunch +
      t.car +
      t.childcare
    : t.base +
      t.overtime +
      t.overtimeNontax +
      t.night +
      t.nightNontax +
      t.holiday +
      t.holidayNontax +
      t.dayoff +
      t.longterm +
      t.sunim +
      t.bonus +
      t.edu +
      t.bojon +
      t.etc +
      t.dang +
      t.lunch +
      t.car +
      t.childcare;
  const laborParts =
    t.lYeon + t.lGun + t.lJang + t.lGo + t.lSo + t.lJi + t.lJiwon + t.lSik + t.lEtc + t.lYearend;
  const corpParts = t.cYeon + t.cGun + t.cJang + t.cGo + t.cSil + t.cSan + t.cOut;
  const dbTaxableSum = sortedData.value.reduce((s, r) => s + dbCommonWageAmount(r.cwhd_taxable), 0);
  const anyRowWage = sortedData.value.some((r) => rowWageMismatch(r));
  const anyRowLabor = sortedData.value.some((r) => isCommonWageLaborTotalMismatch(r));
  const anyRowCorp = sortedData.value.some((r) => isCommonWageCorpTotalMismatch(r));
  const anyRowTaxable =
    isAccountingPreview() && sortedData.value.some((r) => isCommonWageTaxableMismatch(r));

  return {
    wage: anyRowWage || !isCommonWageAmountEqual(wageParts, t.total),
    labor: anyRowLabor || !isCommonWageAmountEqual(laborParts, t.lTotal),
    corp: anyRowCorp || !isCommonWageAmountEqual(corpParts, t.cTotal),
    taxable:
      isAccountingPreview() &&
      (anyRowTaxable || !isCommonWageAmountEqual(dbTaxableSum, t.taxable)),
  };
});

// 동적 colspan 계산
const wageColspan = computed(() => {
  let count = 2; // 기본급, 임금합계 (필수)
  const s = showColumns.value;
  const sc = showClientColumns.value;
  
  if (reportType.value === 'client') {
    // 고객용: 합산 컬럼
    if (sc.overtimeTotal) count++;
    if (sc.nightTotal) count++;
    if (sc.holidayTotal) count++;
  } else {
    // 회계처리용: 연야휴과세 + 연야휴비과세
    if (s.premiumTax) count++;
    if (s.premiumNontax) count++;
  }
  if (s.dayoff) count++;
  if (s.longterm) count++;
  if (s.sunim) count++;
  if (s.bonus) count++;
  if (s.edu) count++;
  if (s.bojon) count++;
  if (s.etc) count++;
  if (s.dang) count++;
  if (s.lunch) count++;
  if (s.car) count++;
  if (s.childcare) count++;
  return count;
});

const empDeductColspan = computed(() => {
  let count = 1; // 공제합계 (필수)
  const s = showColumns.value;
  if (s.lYeon) count++;
  if (s.lGun) count++;
  if (s.lJang) count++;
  if (s.lGo) count++;
  if (s.lSo) count++;
  if (s.lJi) count++;
  if (s.lJiwon) count++;
  if (s.lSik) count++;
  if (s.lEtc) count++;
  if (s.lYearend) count++;
  return count;
});

const corpDeductColspan = computed(() => {
  let count = 1; // 기관합계 (필수)
  const s = showColumns.value;
  if (s.cYeon) count++;
  if (s.cGun) count++;
  if (s.cJang) count++;
  if (s.cGo) count++;
  if (s.cSil) count++;
  if (s.cSan) count++;
  if (s.cOut) count++;
  return count;
});

// 미리보기 열기 (회계처리용 또는 고객용)
const openPreview = (type: 'accounting' | 'client' = 'accounting') => {
  reportType.value = type;
  showModal.value = true;
};

// 미리보기 닫기
const closePreview = () => {
  showModal.value = false;
};

// 현재 선택된 타입에 따라 다운로드
const handleDownload = () => {
  if (reportType.value === 'client') {
    downloadClientReport();
  } else {
    downloadPayrollReport();
  }
};

// 임금대장 엑셀 다운로드
const downloadPayrollReport = async () => {
  if (!props.wageData || props.wageData.length === 0) {
    emit('error', '다운로드할 데이터가 없습니다.');
    return;
  }

  isDownloading.value = true;
  try {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('임금대장');

    // 컬럼 정의 (그룹, 컬럼명, 필드명, 필수여부)
    type ColDef = { group: string; name: string; field: string | null; required?: boolean };
    const allColumns: ColDef[] = [
      // 기본정보 (필수)
      { group: 'basic', name: '순번', field: null, required: true },
      { group: 'basic', name: '성명', field: null, required: true },
      { group: 'basic', name: '생년월일', field: null, required: true },
      { group: 'basic', name: '직종', field: null, required: true },
      // 근로정보 (필수)
      { group: 'work', name: '시급', field: 'cwhd_pay_calc_hourly', required: true },
      { group: 'work', name: '일수', field: 'cwhd_work_days', required: true },
      { group: 'work', name: '시간', field: 'cwhd_work_hours', required: true },
      // 임금구성
      { group: 'wage', name: '기본급', field: 'cwhd_basic', required: true },
      { group: 'wage', name: '연야휴과세', field: '_premium_tax' },
      { group: 'wage', name: '연야휴비과세', field: '_premium_nontax' },
      { group: 'wage', name: '연차', field: 'cwhd_dayoff' },
      { group: 'wage', name: '장기', field: 'cwhd_senior' },
      { group: 'wage', name: '선임', field: 'cwhd_sunim' },
      { group: 'wage', name: '상여', field: 'cwhd_bonus' },
      { group: 'wage', name: '교육', field: 'cwhd_bosu' },
      { group: 'wage', name: '보존', field: 'cwhd_bojon' },
      { group: 'wage', name: '기타', field: 'cwhd_other' },
      { group: 'wage', name: '당직', field: 'cwhd_dang' },
      { group: 'wage', name: '중식비(비과세)', field: 'cwhd_lunch' },
      { group: 'wage', name: '차량(비과세)', field: 'cwhd_car' },
      { group: 'wage', name: '양육(비과세)', field: 'cwhd_child' },
      { group: 'wage', name: '임금합계', field: '_gross_pay', required: true },
      // 조정내역
      { group: 'adjust', name: '과세', field: 'cwhd_taxable', required: true },
      { group: 'adjust', name: '통상', field: 'cwhd_usual', required: true },
      // 근로자공제
      { group: 'empDeduct', name: '국민연금', field: 'cwhd_l_yeon' },
      { group: 'empDeduct', name: '건강보험', field: 'cwhd_l_gun' },
      { group: 'empDeduct', name: '장기요양', field: 'cwhd_l_jang' },
      { group: 'empDeduct', name: '고용보험', field: 'cwhd_l_go' },
      { group: 'empDeduct', name: '소득세', field: 'cwhd_l_so' },
      { group: 'empDeduct', name: '지방세', field: 'cwhd_l_ji' },
      { group: 'empDeduct', name: '지원공제', field: 'cwhd_l_jiwon' },
      { group: 'empDeduct', name: '식비공제', field: 'cwhd_l_sik' },
      { group: 'empDeduct', name: '기타공제', field: 'cwhd_l_etc' },
      { group: 'empDeduct', name: '연말정산', field: 'cwhd_l_yearend' },
      { group: 'empDeduct', name: '근로자공제합계', field: 'cwhd_l_total', required: true },
      { group: 'net', name: '실수령액', field: null, required: true },
      // 기관공제
      { group: 'corpDeduct', name: '국민연금', field: 'cwhd_c_yeon' },
      { group: 'corpDeduct', name: '건강보험', field: 'cwhd_c_gun' },
      { group: 'corpDeduct', name: '장기요양', field: 'cwhd_c_jang' },
      { group: 'corpDeduct', name: '고용보험', field: 'cwhd_c_go' },
      { group: 'corpDeduct', name: '실업급여', field: 'cwhd_c_sil' },
      { group: 'corpDeduct', name: '산재보험', field: 'cwhd_c_san' },
      { group: 'corpDeduct', name: '퇴직금', field: 'cwhd_c_out' },
      { group: 'corpDeduct', name: '기관공제합계', field: 'cwhd_c_total', required: true },
      { group: 'remark', name: '비고', field: null, required: true }
    ];

    const getAccountingFieldValue = (row: CommonWageListRow, field: string | null): number => {
      if (!field) return 0;
      if (field === '_gross_pay') return getRowGrossPay(row);
      if (field === '_premium_tax') return getCommonWagePremiumTaxTotal(row);
      if (field === '_premium_nontax') return getCommonWagePremiumNontaxTotal(row);
      return Number((row as any)[field]) || 0;
    };

    // 각 컬럼별 합계 계산하여 0인 컬럼 필터링
    const payrollRows = reportRows('accounting', props.wageData);

    const hasNonZeroValue = (field: string | null): boolean => {
      if (!field) return true;
      return payrollRows.some(row => amountPresent(getAccountingFieldValue(row, field)));
    };

    // 필수이거나 0이 아닌 값이 있는 컬럼만 포함
    const activeColumns = allColumns.filter(col => col.required || hasNonZeroValue(col.field));

    // 2단 헤더 생성
    const header2Columns = activeColumns.map(col => col.name);

    // 그룹별 시작/끝 인덱스 계산
    const getGroupRange = (groupName: string) => {
      const cols = activeColumns.map((c, i) => ({ ...c, idx: i + 1 })).filter(c => c.group === groupName);
      if (cols.length === 0) return null;
      return { start: cols[0].idx, end: cols[cols.length - 1].idx };
    };

    const basicRange = getGroupRange('basic');
    const workRange = getGroupRange('work');
    const wageRange = getGroupRange('wage');
    const adjustRange = getGroupRange('adjust');
    const empDeductRange = getGroupRange('empDeduct');
    const corpDeductRange = getGroupRange('corpDeduct');
    const netRange = getGroupRange('net');
    const remarkRange = getGroupRange('remark');

    addWageLedgerTitleRow(worksheet, wageLedgerTitle(), header2Columns.length);

    // 1단 헤더 행 추가 (제목행이 1행)
    const header1Row = worksheet.addRow([]);
    if (basicRange) header1Row.getCell(basicRange.start).value = '기본정보';
    if (workRange) header1Row.getCell(workRange.start).value = '근로정보';
    if (wageRange) header1Row.getCell(wageRange.start).value = '임금구성';
    if (adjustRange) header1Row.getCell(adjustRange.start).value = '조정내역';
    if (empDeductRange) header1Row.getCell(empDeductRange.start).value = '근로자공제';
    if (corpDeductRange) header1Row.getCell(corpDeductRange.start).value = '기관공제';
    if (netRange) header1Row.getCell(netRange.start).value = '수령';
    if (remarkRange) header1Row.getCell(remarkRange.start).value = '비고';

    // 1단 헤더 병합
    if (basicRange && basicRange.end > basicRange.start) worksheet.mergeCells(2, basicRange.start, 2, basicRange.end);
    if (workRange && workRange.end > workRange.start) worksheet.mergeCells(2, workRange.start, 2, workRange.end);
    if (wageRange && wageRange.end > wageRange.start) worksheet.mergeCells(2, wageRange.start, 2, wageRange.end);
    if (adjustRange && adjustRange.end > adjustRange.start) worksheet.mergeCells(2, adjustRange.start, 2, adjustRange.end);
    if (empDeductRange && empDeductRange.end > empDeductRange.start) worksheet.mergeCells(2, empDeductRange.start, 2, empDeductRange.end);
    if (corpDeductRange && corpDeductRange.end > corpDeductRange.start) worksheet.mergeCells(2, corpDeductRange.start, 2, corpDeductRange.end);

    // 1단 헤더 스타일
    for (let i = 1; i <= header2Columns.length; i++) {
      const cell = header1Row.getCell(i);
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1e3a5f' } };
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    }

    // 비과세 컬럼 인덱스 찾기 (동적)
    const nontaxColIndices: number[] = [];
    activeColumns.forEach((col, idx) => {
      if (col.name.includes('비과세')) nontaxColIndices.push(idx + 1);
    });

    // 2단 헤더 행 추가
    const header2Row = worksheet.addRow(header2Columns);
    header2Row.eachCell((cell, colNumber) => {
      let bgColor = 'FFD9E1F2';  // 기본색
      if (wageRange && colNumber >= wageRange.start && colNumber <= wageRange.end) bgColor = 'FFE2EFDA';  // 임금구성 연두색
      if (empDeductRange && colNumber >= empDeductRange.start && colNumber <= empDeductRange.end) bgColor = 'FFFCE4D6';  // 근로자공제 살구색
      if (corpDeductRange && colNumber >= corpDeductRange.start && colNumber <= corpDeductRange.end) bgColor = 'FFFFF2CC';  // 기관공제 노랑
      // 비과세 컬럼 파랑 (동적 인덱스)
      if (nontaxColIndices.includes(colNumber)) bgColor = 'FFE0F2FE';
      
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: bgColor } };
      cell.font = { bold: true, size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    // 열 너비 설정
    worksheet.getColumn(1).width = 6;   // 순번
    worksheet.getColumn(2).width = 10;  // 성명
    worksheet.getColumn(3).width = 12;  // 생년월일
    worksheet.getColumn(4).width = 12;  // 직종
    for (let i = 5; i <= header2Columns.length; i++) {
      const colName = header2Columns[i - 1];
      if (colName.includes('합계') || colName === '실수령액') worksheet.getColumn(i).width = 13;
      else if (colName === '비고') worksheet.getColumn(i).width = 10;
      else if (colName === '기본급' || colName === '과세' || colName === '통상' || colName === '연야휴과세' || colName === '연야휴비과세') worksheet.getColumn(i).width = 12;
      else worksheet.getColumn(i).width = 10;
    }

    // 합계 변수
    const totals: Record<string, number> = {};
    activeColumns.forEach(col => { 
      if (col.field || col.name === '실수령액') totals[excelColTotalKey(col)] = 0; 
    });

    // 데이터 행 추가
    payrollRows.forEach((row, index) => {
      const grossPay = getRowGrossPay(row);
      const netPay = getRowNetPay(row);
      const remarkText = calculateAge(getBirthDateStr(row), props.year, props.month);

      // activeColumns 기반 동적 데이터 생성
      const rowData = activeColumns.map((col, colIdx) => {
        if (col.name === '순번') return index + 1;
        if (col.name === '성명') return row.ce_name || '';
        if (col.name === '생년월일') return getBirthDateStr(row);
        if (col.name === '직종') return getJobType(row);
        if (col.name === '실수령액') return netPay;
        if (col.name === '비고') return remarkText;
        if (col.field) return getAccountingFieldValue(row, col.field);
        return '';
      });

      const dataRow = worksheet.addRow(rowData);
      
      // 데이터 행 스타일
      dataRow.eachCell((cell, colNumber) => {
        const col = activeColumns[colNumber - 1];
        if (col && col.group === 'basic') {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF8FAFC' } };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
        } else {
          const isNontaxCol = nontaxColIndices.includes(colNumber);
          let bgColor = 'FFFFFFFF';
          if (isNontaxCol) bgColor = 'FFE0F2FE';
          
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: bgColor } };
          cell.alignment = { horizontal: 'right', vertical: 'middle' };
          cell.numFmt = '#,##0';
        }
        cell.border = {
          top: { style: 'thin', color: { argb: 'FFE5E7EB' } },
          left: { style: 'thin', color: { argb: 'FFE5E7EB' } },
          bottom: { style: 'thin', color: { argb: 'FFE5E7EB' } },
          right: { style: 'thin', color: { argb: 'FFE5E7EB' } }
        };
      });

      // 합계 누적 (숫자 컬럼만)
      activeColumns.forEach((col, idx) => {
        if ((col.field || col.name === '실수령액') && idx >= 4) {
          const val = rowData[idx];
          if (typeof val === 'number') {
            const key = excelColTotalKey(col);
            totals[key] = (totals[key] || 0) + val;
          }
        }
      });
    });

    // 합계 행 (동적 컬럼 기반)
    const totalRowData = activeColumns.map((col, idx) => {
      if (col.name === '순번') return '';
      if (col.name === '성명') return '합계';
      if (col.name === '생년월일' || col.name === '직종' || col.name === '비고') return '';
      return totals[excelColTotalKey(col)] || 0;
    });

    const totalRow = worksheet.addRow(totalRowData);
    const basicEnd = basicRange?.end || 4;
    const remarkStart = remarkRange?.start || activeColumns.length;
    totalRow.eachCell((cell, colNumber) => {
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF2CC' } };
      cell.font = { bold: true, size: 10 };
      cell.alignment = { horizontal: colNumber <= basicEnd ? 'center' : 'right', vertical: 'middle' };
      cell.border = { top: { style: 'medium' }, left: { style: 'thin' }, bottom: { style: 'medium' }, right: { style: 'thin' } };
      if (colNumber > basicEnd && colNumber < remarkStart) {
        cell.numFmt = '#,##0';
      }
    });

    // 파일 다운로드
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileName = `회계처리용_임금대장_${props.year}년${String(props.month).padStart(2, '0')}월.xlsx`;
    saveAs(blob, fileName);
  } catch (error) {
    console.error('엑셀 다운로드 오류:', error);
    emit('error', '임금대장 다운로드 중 오류가 발생했습니다.');
  } finally {
    isDownloading.value = false;
  }
};

// 고객용 임금대장 엑셀 다운로드 (과세/비과세 구분 없이, 조정내역 제외)
const downloadClientReport = async () => {
  if (!props.wageData || props.wageData.length === 0) {
    emit('error', '다운로드할 데이터가 없습니다.');
    return;
  }

  isDownloading.value = true;
  try {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('임금대장');

    // 고객용 컬럼 정의 (과세/비과세 합산, 조정내역 제외)
    type ColDef = { group: string; name: string; field: string | null; required?: boolean };
    const allColumns: ColDef[] = [
      // 기본정보 (필수)
      { group: 'basic', name: '순번', field: null, required: true },
      { group: 'basic', name: '성명', field: null, required: true },
      { group: 'basic', name: '생년월일', field: null, required: true },
      { group: 'basic', name: '직종', field: null, required: true },
      // 근로정보 (필수)
      { group: 'work', name: '시급', field: 'cwhd_pay_calc_hourly', required: true },
      { group: 'work', name: '일수', field: 'cwhd_work_days', required: true },
      { group: 'work', name: '시간', field: 'cwhd_work_hours', required: true },
      // 임금구성 (과세+비과세 합산)
      { group: 'wage', name: '기본급', field: 'cwhd_basic', required: true },
      { group: 'wage', name: '연장수당', field: '_overtime_total' },
      { group: 'wage', name: '야간수당', field: '_night_total' },
      { group: 'wage', name: '휴일수당', field: '_holiday_total' },
      { group: 'wage', name: '연차수당', field: 'cwhd_dayoff' },
      { group: 'wage', name: '장기근속', field: 'cwhd_senior' },
      { group: 'wage', name: '선임수당', field: 'cwhd_sunim' },
      { group: 'wage', name: '상여금', field: 'cwhd_bonus' },
      { group: 'wage', name: '교육비', field: 'cwhd_bosu' },
      { group: 'wage', name: '보존수당', field: 'cwhd_bojon' },
      { group: 'wage', name: '기타수당', field: 'cwhd_other' },
      { group: 'wage', name: '당직수당', field: 'cwhd_dang' },
      { group: 'wage', name: COMMON_WAGE_CLIENT_NONTAX_LABELS.lunch, field: 'cwhd_lunch' },
      { group: 'wage', name: COMMON_WAGE_CLIENT_NONTAX_LABELS.car, field: 'cwhd_car' },
      { group: 'wage', name: COMMON_WAGE_CLIENT_NONTAX_LABELS.child, field: 'cwhd_child' },
      { group: 'wage', name: '임금합계', field: '_gross_pay', required: true },
      // 근로자공제
      { group: 'empDeduct', name: '국민연금', field: 'cwhd_l_yeon' },
      { group: 'empDeduct', name: '건강보험', field: 'cwhd_l_gun' },
      { group: 'empDeduct', name: '장기요양', field: 'cwhd_l_jang' },
      { group: 'empDeduct', name: '고용보험', field: 'cwhd_l_go' },
      { group: 'empDeduct', name: '소득세', field: 'cwhd_l_so' },
      { group: 'empDeduct', name: '지방세', field: 'cwhd_l_ji' },
      { group: 'empDeduct', name: '지원공제', field: 'cwhd_l_jiwon' },
      { group: 'empDeduct', name: '식비공제', field: 'cwhd_l_sik' },
      { group: 'empDeduct', name: '기타공제', field: 'cwhd_l_etc' },
      { group: 'empDeduct', name: '연말정산', field: 'cwhd_l_yearend' },
      { group: 'empDeduct', name: '근로자공제합계', field: 'cwhd_l_total', required: true },
      { group: 'net', name: '실수령액', field: null, required: true },
      // 기관공제
      { group: 'corpDeduct', name: '국민연금', field: 'cwhd_c_yeon' },
      { group: 'corpDeduct', name: '건강보험', field: 'cwhd_c_gun' },
      { group: 'corpDeduct', name: '장기요양', field: 'cwhd_c_jang' },
      { group: 'corpDeduct', name: '고용보험', field: 'cwhd_c_go' },
      { group: 'corpDeduct', name: '실업급여', field: 'cwhd_c_sil' },
      { group: 'corpDeduct', name: '산재보험', field: 'cwhd_c_san' },
      { group: 'corpDeduct', name: '퇴직금', field: 'cwhd_c_out' },
      { group: 'corpDeduct', name: '기관공제합계', field: 'cwhd_c_total', required: true },
      { group: 'remark', name: '비고', field: null, required: true }
    ];

    // 합산 값 계산 헬퍼 (정책 단일 소스)
    const getFieldValue = (row: CommonWageListRow, field: string | null): number => {
      if (!field) return 0;
      if (field === '_overtime_total') return getCommonWageOvertimeTotal(row);
      if (field === '_night_total') return getCommonWageNightTotal(row);
      if (field === '_holiday_total') return getCommonWageHolidayTotal(row);
      if (field === '_gross_pay') return getRowGrossPay(row);
      return Number((row as any)[field]) || 0;
    };

    // 각 컬럼별 합계 계산하여 0인 컬럼 필터링
    const clientRows = reportRows('client', props.wageData);
    const hasNonZeroValue = (field: string | null): boolean => {
      if (!field) return true;
      return clientRows.some(row => amountPresent(getFieldValue(row, field)));
    };

    // 필수이거나 0이 아닌 값이 있는 컬럼만 포함
    const activeColumns = allColumns.filter(col => col.required || hasNonZeroValue(col.field));

    // 2단 헤더 생성
    const header2Columns = activeColumns.map(col => col.name);

    // 그룹별 시작/끝 인덱스 계산
    const getGroupRange = (groupName: string) => {
      const cols = activeColumns.map((c, i) => ({ ...c, idx: i + 1 })).filter(c => c.group === groupName);
      if (cols.length === 0) return null;
      return { start: cols[0].idx, end: cols[cols.length - 1].idx };
    };

    const basicRange = getGroupRange('basic');
    const workRange = getGroupRange('work');
    const wageRange = getGroupRange('wage');
    const empDeductRange = getGroupRange('empDeduct');
    const corpDeductRange = getGroupRange('corpDeduct');
    const netRange = getGroupRange('net');
    const remarkRange = getGroupRange('remark');

    addWageLedgerTitleRow(worksheet, wageLedgerTitle(), header2Columns.length);

    // 1단 헤더 행 추가 (제목행이 1행)
    const header1Row = worksheet.addRow([]);
    if (basicRange) header1Row.getCell(basicRange.start).value = '기본정보';
    if (workRange) header1Row.getCell(workRange.start).value = '근로정보';
    if (wageRange) header1Row.getCell(wageRange.start).value = '임금구성';
    if (empDeductRange) header1Row.getCell(empDeductRange.start).value = '근로자공제';
    if (corpDeductRange) header1Row.getCell(corpDeductRange.start).value = '기관공제';
    if (netRange) header1Row.getCell(netRange.start).value = '수령';
    if (remarkRange) header1Row.getCell(remarkRange.start).value = '비고';

    // 1단 헤더 병합
    if (basicRange && basicRange.end > basicRange.start) worksheet.mergeCells(2, basicRange.start, 2, basicRange.end);
    if (workRange && workRange.end > workRange.start) worksheet.mergeCells(2, workRange.start, 2, workRange.end);
    if (wageRange && wageRange.end > wageRange.start) worksheet.mergeCells(2, wageRange.start, 2, wageRange.end);
    if (empDeductRange && empDeductRange.end > empDeductRange.start) worksheet.mergeCells(2, empDeductRange.start, 2, empDeductRange.end);
    if (corpDeductRange && corpDeductRange.end > corpDeductRange.start) worksheet.mergeCells(2, corpDeductRange.start, 2, corpDeductRange.end);

    // 1단 헤더 스타일
    for (let i = 1; i <= header2Columns.length; i++) {
      const cell = header1Row.getCell(i);
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1e3a5f' } };
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    }

    // 2단 헤더 행 추가
    const header2Row = worksheet.addRow(header2Columns);
    header2Row.eachCell((cell, colNumber) => {
      let bgColor = 'FFD9E1F2';
      if (wageRange && colNumber >= wageRange.start && colNumber <= wageRange.end) bgColor = 'FFE2EFDA';
      if (empDeductRange && colNumber >= empDeductRange.start && colNumber <= empDeductRange.end) bgColor = 'FFFCE4D6';
      if (corpDeductRange && colNumber >= corpDeductRange.start && colNumber <= corpDeductRange.end) bgColor = 'FFFFF2CC';
      
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: bgColor } };
      cell.font = { bold: true, size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    // 열 너비 설정
    worksheet.getColumn(1).width = 6;
    worksheet.getColumn(2).width = 10;
    worksheet.getColumn(3).width = 12;
    worksheet.getColumn(4).width = 12;
    for (let i = 5; i <= header2Columns.length; i++) {
      const colName = header2Columns[i - 1];
      if (colName.includes('합계') || colName === '실수령액') worksheet.getColumn(i).width = 13;
      else if (colName === '비고') worksheet.getColumn(i).width = 10;
      else if (colName === '기본급') worksheet.getColumn(i).width = 12;
      else worksheet.getColumn(i).width = 10;
    }

    // 합계 변수
    const totals: Record<string, number> = {};
    activeColumns.forEach(col => { 
      if (col.field || col.name === '실수령액') totals[excelColTotalKey(col)] = 0; 
    });

    const sortedData = reportRows('client', props.wageData);

    // 데이터 행 추가
    sortedData.forEach((row, index) => {
      const netPay = getRowNetPay(row);
      const remarkText = calculateAge(getBirthDateStr(row), props.year, props.month);

      const rowData = activeColumns.map((col) => {
        if (col.name === '순번') return index + 1;
        if (col.name === '성명') return row.ce_name || '';
        if (col.name === '생년월일') return getBirthDateStr(row);
        if (col.name === '직종') return getJobType(row);
        if (col.name === '실수령액') return netPay;
        if (col.name === '비고') return remarkText;
        if (col.field) return getFieldValue(row, col.field);
        return '';
      });

      const dataRow = worksheet.addRow(rowData);
      const basicEnd = basicRange?.end || 4;
      const remarkStart = remarkRange?.start || activeColumns.length;
      
      dataRow.eachCell((cell, colNumber) => {
        const col = activeColumns[colNumber - 1];
        cell.alignment = { horizontal: colNumber <= basicEnd ? 'center' : 'right', vertical: 'middle' };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        if (colNumber > basicEnd && colNumber < remarkStart) {
          cell.numFmt = '#,##0';
        }
        // 합계 누적
        if (col.field) {
          const key = excelColTotalKey(col);
          totals[key] = (totals[key] || 0) + getFieldValue(row, col.field);
        }
        if (col.name === '실수령액') totals['실수령액'] = (totals['실수령액'] || 0) + netPay;
      });
    });

    // 합계 행
    const totalRowData = activeColumns.map((col) => {
      if (col.name === '순번') return '';
      if (col.name === '성명') return '합계';
      if (col.name === '생년월일' || col.name === '직종' || col.name === '비고') return '';
      return totals[excelColTotalKey(col)] || 0;
    });

    const totalRow = worksheet.addRow(totalRowData);
    const basicEnd = basicRange?.end || 4;
    const remarkStart = remarkRange?.start || activeColumns.length;
    totalRow.eachCell((cell, colNumber) => {
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF2CC' } };
      cell.font = { bold: true, size: 10 };
      cell.alignment = { horizontal: colNumber <= basicEnd ? 'center' : 'right', vertical: 'middle' };
      cell.border = { top: { style: 'medium' }, left: { style: 'thin' }, bottom: { style: 'medium' }, right: { style: 'thin' } };
      if (colNumber > basicEnd && colNumber < remarkStart) {
        cell.numFmt = '#,##0';
      }
    });

    // 파일 다운로드
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileName = `임금대장_${props.year}년${String(props.month).padStart(2, '0')}월.xlsx`;
    saveAs(blob, fileName);
  } catch (error) {
    console.error('고객용 임금대장 다운로드 오류:', error);
    emit('error', '임금대장 다운로드 중 오류가 발생했습니다.');
  } finally {
    isDownloading.value = false;
  }
};

__expose({
  downloadPayrollReport,
  downloadClientReport,
  openPreview
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (showModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "wage-report-modal-overlay",
          onClick: _withModifiers(closePreview, ["self"])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h3", null, _toDisplayString(reportType.value === 'accounting' ? '회계처리용 ' : '') + "임금대장 미리보기 (" + _toDisplayString(__props.year) + "년 " + _toDisplayString(__props.month) + "월) ", 1),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                  class: "download-btn",
                  onClick: handleDownload,
                  disabled: isDownloading.value
                }, [
                  (isDownloading.value)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        size: "16",
                        class: "spin"
                      }, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                          _createTextVNode("mdi-loading", -1)
                        ]))]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        size: "16"
                      }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode("mdi-download", -1)
                        ]))]),
                        _: 1
                      })),
                  _createTextVNode(" " + _toDisplayString(isDownloading.value ? '다운로드 중...' : '엑셀 다운로드'), 1)
                ], 8, _hoisted_4),
                _createElementVNode("button", {
                  class: "close-btn",
                  onClick: closePreview
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_8, [
                      _cache[3] || (_cache[3] = _createElementVNode("th", {
                        colspan: "4",
                        class: "section-basic"
                      }, "기본정보", -1)),
                      _cache[4] || (_cache[4] = _createElementVNode("th", {
                        colspan: "3",
                        class: "section-work"
                      }, "근로정보", -1)),
                      _createElementVNode("th", {
                        colspan: wageColspan.value,
                        class: "section-wage"
                      }, "임금구성", 8, _hoisted_9),
                      (reportType.value === 'accounting')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_10, "조정내역"))
                        : _createCommentVNode("", true),
                      _createElementVNode("th", {
                        colspan: empDeductColspan.value,
                        class: "section-emp-deduct"
                      }, "근로자공제", 8, _hoisted_11),
                      _cache[5] || (_cache[5] = _createElementVNode("th", { class: "section-net" }, "수령", -1)),
                      _createElementVNode("th", {
                        colspan: corpDeductColspan.value,
                        class: "section-center-deduct"
                      }, "기관공제", 8, _hoisted_12)
                    ]),
                    _createElementVNode("tr", _hoisted_13, [
                      _cache[8] || (_cache[8] = _createElementVNode("th", null, "순번", -1)),
                      _cache[9] || (_cache[9] = _createElementVNode("th", null, "성명", -1)),
                      _cache[10] || (_cache[10] = _createElementVNode("th", null, "생년월일", -1)),
                      _cache[11] || (_cache[11] = _createElementVNode("th", null, "직종", -1)),
                      _cache[12] || (_cache[12] = _createElementVNode("th", null, "시급", -1)),
                      _cache[13] || (_cache[13] = _createElementVNode("th", null, "일수", -1)),
                      _cache[14] || (_cache[14] = _createElementVNode("th", null, "시간", -1)),
                      _cache[15] || (_cache[15] = _createElementVNode("th", null, "기본급", -1)),
                      (reportType.value === 'accounting')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (showColumns.value.premiumTax)
                              ? (_openBlock(), _createElementBlock("th", _hoisted_14, "연야휴과세"))
                              : _createCommentVNode("", true),
                            (showColumns.value.premiumNontax)
                              ? (_openBlock(), _createElementBlock("th", _hoisted_15, "연야휴비과세"))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (showClientColumns.value.overtimeTotal)
                              ? (_openBlock(), _createElementBlock("th", _hoisted_16, "연장수당"))
                              : _createCommentVNode("", true),
                            (showClientColumns.value.nightTotal)
                              ? (_openBlock(), _createElementBlock("th", _hoisted_17, "야간수당"))
                              : _createCommentVNode("", true),
                            (showClientColumns.value.holidayTotal)
                              ? (_openBlock(), _createElementBlock("th", _hoisted_18, "휴일수당"))
                              : _createCommentVNode("", true)
                          ], 64)),
                      (showColumns.value.dayoff)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_19, "연차"))
                        : _createCommentVNode("", true),
                      (showColumns.value.longterm)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_20, "장기"))
                        : _createCommentVNode("", true),
                      (showColumns.value.sunim)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_21, "선임"))
                        : _createCommentVNode("", true),
                      (showColumns.value.bonus)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_22, "상여"))
                        : _createCommentVNode("", true),
                      (showColumns.value.edu)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_23, "교육"))
                        : _createCommentVNode("", true),
                      (showColumns.value.bojon)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_24, "보존"))
                        : _createCommentVNode("", true),
                      (showColumns.value.etc)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_25, "기타"))
                        : _createCommentVNode("", true),
                      (showColumns.value.dang)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_26, "당직"))
                        : _createCommentVNode("", true),
                      (showColumns.value.lunch)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_27, _toDisplayString(reportType.value === 'client' ? _unref(COMMON_WAGE_CLIENT_NONTAX_LABELS).lunch : '중식비(비과세)'), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.car)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_28, _toDisplayString(reportType.value === 'client' ? _unref(COMMON_WAGE_CLIENT_NONTAX_LABELS).car : '차량(비과세)'), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.childcare)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_29, _toDisplayString(reportType.value === 'client' ? _unref(COMMON_WAGE_CLIENT_NONTAX_LABELS).child : '양육(비과세)'), 1))
                        : _createCommentVNode("", true),
                      _cache[16] || (_cache[16] = _createElementVNode("th", { class: "total-col" }, "임금합계", -1)),
                      (reportType.value === 'accounting')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 13 }, [
                            _cache[6] || (_cache[6] = _createElementVNode("th", null, "과세", -1)),
                            _cache[7] || (_cache[7] = _createElementVNode("th", null, "통상", -1))
                          ], 64))
                        : _createCommentVNode("", true),
                      (showColumns.value.lYeon)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_30, "국민연금"))
                        : _createCommentVNode("", true),
                      (showColumns.value.lGun)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_31, "건강보험"))
                        : _createCommentVNode("", true),
                      (showColumns.value.lJang)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_32, "장기요양"))
                        : _createCommentVNode("", true),
                      (showColumns.value.lGo)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_33, "고용보험"))
                        : _createCommentVNode("", true),
                      (showColumns.value.lSo)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_34, "소득세"))
                        : _createCommentVNode("", true),
                      (showColumns.value.lJi)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_35, "지방세"))
                        : _createCommentVNode("", true),
                      (showColumns.value.lJiwon)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_36, "지원공제"))
                        : _createCommentVNode("", true),
                      (showColumns.value.lSik)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_37, "식비공제"))
                        : _createCommentVNode("", true),
                      (showColumns.value.lEtc)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_38, "기타공제"))
                        : _createCommentVNode("", true),
                      (showColumns.value.lYearend)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_39, "연말정산"))
                        : _createCommentVNode("", true),
                      _cache[17] || (_cache[17] = _createElementVNode("th", { class: "total-col" }, "공제합계", -1)),
                      _cache[18] || (_cache[18] = _createElementVNode("th", { class: "net-col" }, "실수령액", -1)),
                      (showColumns.value.cYeon)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_40, "국민연금"))
                        : _createCommentVNode("", true),
                      (showColumns.value.cGun)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_41, "건강보험"))
                        : _createCommentVNode("", true),
                      (showColumns.value.cJang)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_42, "장기요양"))
                        : _createCommentVNode("", true),
                      (showColumns.value.cGo)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_43, "고용보험"))
                        : _createCommentVNode("", true),
                      (showColumns.value.cSil)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_44, "실업급여"))
                        : _createCommentVNode("", true),
                      (showColumns.value.cSan)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_45, "산재보험"))
                        : _createCommentVNode("", true),
                      (showColumns.value.cOut)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_46, "퇴직금"))
                        : _createCommentVNode("", true),
                      _cache[19] || (_cache[19] = _createElementVNode("th", { class: "total-col" }, "기관합계", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedData.value, (row, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: row.emp_match_key || `${row.ce_name}|${row.ce_birth_date || ''}`,
                        class: "data-row"
                      }, [
                        _createElementVNode("td", _hoisted_47, _toDisplayString(index + 1), 1),
                        _createElementVNode("td", _hoisted_48, _toDisplayString(row.ce_name), 1),
                        _createElementVNode("td", _hoisted_49, _toDisplayString(getBirthDateStr(row)), 1),
                        _createElementVNode("td", _hoisted_50, _toDisplayString(getJobType(row)), 1),
                        _createElementVNode("td", _hoisted_51, _toDisplayString(formatNumber(row.cwhd_pay_calc_hourly)), 1),
                        _createElementVNode("td", _hoisted_52, _toDisplayString(formatDecimal(row.cwhd_work_days)), 1),
                        _createElementVNode("td", _hoisted_53, _toDisplayString(formatDecimal(row.cwhd_work_hours)), 1),
                        _createElementVNode("td", _hoisted_54, _toDisplayString(formatNumber(row.cwhd_basic)), 1),
                        (reportType.value === 'accounting')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (showColumns.value.premiumTax)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_55, _toDisplayString(formatNumber(_unref(getCommonWagePremiumTaxTotal)(row))), 1))
                                : _createCommentVNode("", true),
                              (showColumns.value.premiumNontax)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_56, _toDisplayString(formatNumber(_unref(getCommonWagePremiumNontaxTotal)(row))), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (showClientColumns.value.overtimeTotal)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_57, _toDisplayString(formatNumber(getOvertimeTotal(row))), 1))
                                : _createCommentVNode("", true),
                              (showClientColumns.value.nightTotal)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_58, _toDisplayString(formatNumber(getNightTotal(row))), 1))
                                : _createCommentVNode("", true),
                              (showClientColumns.value.holidayTotal)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_59, _toDisplayString(formatNumber(getHolidayTotal(row))), 1))
                                : _createCommentVNode("", true)
                            ], 64)),
                        (showColumns.value.dayoff)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_60, _toDisplayString(formatNumber(row.cwhd_dayoff)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.longterm)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_61, _toDisplayString(formatNumber(row.cwhd_senior)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.sunim)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_62, _toDisplayString(formatNumber(row.cwhd_sunim)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.bonus)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_63, _toDisplayString(formatNumber(row.cwhd_bonus)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.edu)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_64, _toDisplayString(formatNumber(row.cwhd_bosu)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.bojon)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_65, _toDisplayString(formatNumber(row.cwhd_bojon)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.etc)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_66, _toDisplayString(formatNumber(row.cwhd_other)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.dang)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_67, _toDisplayString(formatNumber(row.cwhd_dang)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.lunch)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_68, _toDisplayString(formatNumber(row.cwhd_lunch)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.car)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_69, _toDisplayString(formatNumber(row.cwhd_car)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.childcare)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_70, _toDisplayString(formatNumber(row.cwhd_child)), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", {
                          class: _normalizeClass(["right total-col", { 'total-mismatch': rowWageMismatch(row) }]),
                          title: rowWageMismatch(row) ? '항목 합과 임금합계가 일치하지 않습니다' : undefined
                        }, _toDisplayString(formatNumber(getRowGrossPay(row))), 11, _hoisted_71),
                        (reportType.value === 'accounting')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 13 }, [
                              _createElementVNode("td", {
                                class: _normalizeClass(["right", { 'total-mismatch': rowTaxableMismatch(row) }]),
                                title: rowTaxableMismatch(row) ? '항목 기준 과세와 저장 과세가 일치하지 않습니다' : undefined
                              }, _toDisplayString(formatNumber(row.cwhd_taxable)), 11, _hoisted_72),
                              _createElementVNode("td", _hoisted_73, _toDisplayString(formatNumber(row.cwhd_usual)), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (showColumns.value.lYeon)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_74, _toDisplayString(formatNumber(row.cwhd_l_yeon)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.lGun)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_75, _toDisplayString(formatNumber(row.cwhd_l_gun)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.lJang)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_76, _toDisplayString(formatNumber(row.cwhd_l_jang)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.lGo)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_77, _toDisplayString(formatNumber(row.cwhd_l_go)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.lSo)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_78, _toDisplayString(formatNumber(row.cwhd_l_so)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.lJi)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_79, _toDisplayString(formatNumber(row.cwhd_l_ji)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.lJiwon)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_80, _toDisplayString(formatNumber(row.cwhd_l_jiwon)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.lSik)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_81, _toDisplayString(formatNumber(row.cwhd_l_sik)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.lEtc)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_82, _toDisplayString(formatNumber(row.cwhd_l_etc)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.lYearend)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_83, _toDisplayString(formatNumber(row.cwhd_l_yearend)), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", {
                          class: _normalizeClass(["right total-col", { 'total-mismatch': rowLaborMismatch(row) }]),
                          title: rowLaborMismatch(row) ? '근로자공제 항목 합과 공제합계가 일치하지 않습니다' : undefined
                        }, _toDisplayString(formatNumber(row.cwhd_l_total)), 11, _hoisted_84),
                        _createElementVNode("td", _hoisted_85, _toDisplayString(formatNumber(getRowNetPay(row))), 1),
                        (showColumns.value.cYeon)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_86, _toDisplayString(formatNumber(row.cwhd_c_yeon)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.cGun)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_87, _toDisplayString(formatNumber(row.cwhd_c_gun)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.cJang)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_88, _toDisplayString(formatNumber(row.cwhd_c_jang)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.cGo)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_89, _toDisplayString(formatNumber(row.cwhd_c_go)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.cSil)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_90, _toDisplayString(formatNumber(row.cwhd_c_sil)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.cSan)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_91, _toDisplayString(formatNumber(row.cwhd_c_san)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.cOut)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_92, _toDisplayString(formatNumber(row.cwhd_c_out)), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", {
                          class: _normalizeClass(["right total-col", { 'total-mismatch': rowCorpMismatch(row) }]),
                          title: rowCorpMismatch(row) ? '기관공제 항목 합과 기관합계가 일치하지 않습니다' : undefined
                        }, _toDisplayString(formatNumber(row.cwhd_c_total)), 11, _hoisted_93)
                      ]))
                    }), 128)),
                    _createElementVNode("tr", _hoisted_94, [
                      _cache[20] || (_cache[20] = _createElementVNode("td", {
                        class: "center",
                        colspan: "4"
                      }, "합계", -1)),
                      _cache[21] || (_cache[21] = _createElementVNode("td", {
                        class: "right",
                        colspan: "3"
                      }, null, -1)),
                      _createElementVNode("td", _hoisted_95, _toDisplayString(formatNumber(totals.value.base)), 1),
                      (reportType.value === 'accounting')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (showColumns.value.premiumTax)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_96, _toDisplayString(formatNumber(totals.value.premiumTax)), 1))
                              : _createCommentVNode("", true),
                            (showColumns.value.premiumNontax)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_97, _toDisplayString(formatNumber(totals.value.premiumNontax)), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (showClientColumns.value.overtimeTotal)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_98, _toDisplayString(formatNumber(totals.value.overtimeTotal)), 1))
                              : _createCommentVNode("", true),
                            (showClientColumns.value.nightTotal)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_99, _toDisplayString(formatNumber(totals.value.nightTotal)), 1))
                              : _createCommentVNode("", true),
                            (showClientColumns.value.holidayTotal)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_100, _toDisplayString(formatNumber(totals.value.holidayTotal)), 1))
                              : _createCommentVNode("", true)
                          ], 64)),
                      (showColumns.value.dayoff)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_101, _toDisplayString(formatNumber(totals.value.dayoff)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.longterm)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_102, _toDisplayString(formatNumber(totals.value.longterm)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.sunim)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_103, _toDisplayString(formatNumber(totals.value.sunim)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.bonus)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_104, _toDisplayString(formatNumber(totals.value.bonus)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.edu)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_105, _toDisplayString(formatNumber(totals.value.edu)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.bojon)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_106, _toDisplayString(formatNumber(totals.value.bojon)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.etc)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_107, _toDisplayString(formatNumber(totals.value.etc)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.dang)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_108, _toDisplayString(formatNumber(totals.value.dang)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.lunch)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_109, _toDisplayString(formatNumber(totals.value.lunch)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.car)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_110, _toDisplayString(formatNumber(totals.value.car)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.childcare)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_111, _toDisplayString(formatNumber(totals.value.childcare)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", {
                        class: _normalizeClass(["right total-col", { 'total-mismatch': footerMismatch.value.wage }]),
                        title: footerMismatch.value.wage ? '임금 항목 합과 임금합계가 일치하지 않습니다' : undefined
                      }, _toDisplayString(formatNumber(totals.value.total)), 11, _hoisted_112),
                      (reportType.value === 'accounting')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 13 }, [
                            _createElementVNode("td", {
                              class: _normalizeClass(["right", { 'total-mismatch': footerMismatch.value.taxable }]),
                              title: footerMismatch.value.taxable ? '과세 합계가 일치하지 않습니다' : undefined
                            }, _toDisplayString(formatNumber(totals.value.taxable)), 11, _hoisted_113),
                            _createElementVNode("td", _hoisted_114, _toDisplayString(formatNumber(totals.value.usual)), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (showColumns.value.lYeon)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_115, _toDisplayString(formatNumber(totals.value.lYeon)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.lGun)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_116, _toDisplayString(formatNumber(totals.value.lGun)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.lJang)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_117, _toDisplayString(formatNumber(totals.value.lJang)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.lGo)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_118, _toDisplayString(formatNumber(totals.value.lGo)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.lSo)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_119, _toDisplayString(formatNumber(totals.value.lSo)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.lJi)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_120, _toDisplayString(formatNumber(totals.value.lJi)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.lJiwon)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_121, _toDisplayString(formatNumber(totals.value.lJiwon)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.lSik)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_122, _toDisplayString(formatNumber(totals.value.lSik)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.lEtc)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_123, _toDisplayString(formatNumber(totals.value.lEtc)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.lYearend)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_124, _toDisplayString(formatNumber(totals.value.lYearend)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", {
                        class: _normalizeClass(["right total-col", { 'total-mismatch': footerMismatch.value.labor }]),
                        title: footerMismatch.value.labor ? '근로자공제 항목 합과 공제합계가 일치하지 않습니다' : undefined
                      }, _toDisplayString(formatNumber(totals.value.lTotal)), 11, _hoisted_125),
                      _createElementVNode("td", _hoisted_126, _toDisplayString(formatNumber(totals.value.netPay)), 1),
                      (showColumns.value.cYeon)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_127, _toDisplayString(formatNumber(totals.value.cYeon)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.cGun)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_128, _toDisplayString(formatNumber(totals.value.cGun)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.cJang)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_129, _toDisplayString(formatNumber(totals.value.cJang)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.cGo)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_130, _toDisplayString(formatNumber(totals.value.cGo)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.cSil)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_131, _toDisplayString(formatNumber(totals.value.cSil)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.cSan)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_132, _toDisplayString(formatNumber(totals.value.cSan)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.cOut)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_133, _toDisplayString(formatNumber(totals.value.cOut)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", {
                        class: _normalizeClass(["right total-col", { 'total-mismatch': footerMismatch.value.corp }]),
                        title: footerMismatch.value.corp ? '기관공제 항목 합과 기관합계가 일치하지 않습니다' : undefined
                      }, _toDisplayString(formatNumber(totals.value.cTotal)), 11, _hoisted_134)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})